import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './features/auth/AuthProvider';
import { LoginPage } from './features/auth/LoginPage';
import { RequireAuth } from './features/auth/RequireAuth';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { HoldingsPage } from './features/holdings/HoldingsPage';
import { RealizedPage } from './features/realized/RealizedPage';
import { SettingsPage } from './features/settings/SettingsPage';
import { AppLayout } from './shared/AppLayout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ราคามี cache ฝั่ง server อยู่แล้ว (spec Section 6.1) ไม่ต้องให้ client ยิงซ้ำเองบ่อย ๆ
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* เปิด flag ของ v7 ไว้ล่วงหน้า — ปิด warning ใน console และลดงานตอนอัปเกรดจริง */}
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              element={
                <RequireAuth>
                  <AppLayout />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="holdings" element={<HoldingsPage />} />
              <Route path="realized" element={<RealizedPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            <Route
              path="*"
              element={
                <main className="flex min-h-dvh flex-col items-center justify-center gap-3">
                  <span className="font-pixel text-sm text-down">404</span>
                  <span className="text-sm text-ink-400">ไม่พบหน้านี้</span>
                </main>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
